module.exports = __webpack_public_path__ + "img/fmiti.1592d819.png";